//
//  components/apps/AppStoreBadge/AppStoreBadge.tsx
//  TownLIT
//
//  Created by Hossein Sakkaki on 2026-08-19.
//  Last Update by Hossein Sakkaki on 2026-08-19.
//

import { TOWNLIT_APP_STORE } from "../../../config/townlitDistribution";

import "./AppStoreBadge.css";

type AppStoreBadgeProps = {
  className?: string;
};

export default function AppStoreBadge({
  className,
}: AppStoreBadgeProps) {
  const classes = [
    "app-store-badge-link",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <a
      href={TOWNLIT_APP_STORE.url}
      className={classes}
      aria-label="Download TownLIT on the App Store"
      title="Download TownLIT on the App Store"
    >
      <img
        src={TOWNLIT_APP_STORE.badgeSrc}
        alt="Download on the App Store"
        className="app-store-badge-image"
      />
    </a>
  );
}